import moment from 'moment';
import { GLOBAL_DATE_FORMAT, SERVICES } from 'constant';
import { Link as MuiLink, IconButton, Tooltip, Typography, Stack, Checkbox } from '@mui/material';
import { utcToLocal } from 'utils/time-conversion';
import PatientLink from 'components/common/PatientLink';
import { Link } from 'react-router-dom';
import { encriptId } from 'utils/encription';
import PrintIcon from '@mui/icons-material/Print';

export const allyProps = {
    flex: 1,
    sortable: false
};

export const cols = (hasPermission, isEval, handleView, evalsSelectAll, checkedRows, handleRowSelectionChange, handleAllSelect) => [
    {
        sortable: false,
        field: 'checkbox',
        renderHeader: () => <Checkbox checked={evalsSelectAll} onChange={handleAllSelect} />,
        renderCell: (params) => (
            <Checkbox
                checked={checkedRows.includes(params.row.id)}
                onChange={() => {
                    handleRowSelectionChange(params.row.id);
                }}
            />
        ),
        width: 100
    },
    {
        field: 'date',
        headerName: 'Date',
        valueGetter: (value, row) => moment.utc(row?.date).local().format(GLOBAL_DATE_FORMAT),
        ...allyProps
    },
    {
        field: 'patient__name',
        headerName: 'Patient',
        ...allyProps,
        renderCell: (params) => (
            <Typography variant="body1">
                {hasPermission(['patient_edit']) ? (
                    <MuiLink target="_blank" underline="none" component={Link} to={`/edit-patient/${encriptId(params?.row.patient?.id)}`}>
                        {params?.row.patient?.name}
                    </MuiLink>
                ) : (
                    <Typography variant="body1">{params?.row.patient?.name}</Typography>
                )}
            </Typography>
        )
    },
    {
        field: 'service',
        headerName: 'Service',
        ...allyProps,
        valueGetter: (value, row) =>
            isEval ? SERVICES.find((item) => item.id === row?.service)?.name : SERVICES.find((item) => item.id === row?.service?.id)?.name
    },
    {
        field: 'location',
        headerName: 'Location',
        ...allyProps,
        valueGetter: (value, row) => row?.location?.name
    },
    {
        field: 'employee',
        headerName: 'Therapist',
        ...allyProps,
        valueGetter: (value, row) => `${row?.employee?.name || ''} ${row?.employee?.credentials || ''}`
    },
    {
        field: 'actions',
        headerName: 'Actions',
        renderCell: (params) => (
            <Stack
                direction="row"
                sx={{
                    alignItems: "center",
                    width: '100%'
                }}>
                <Tooltip title="Print">
                    <IconButton color="secondary" onClick={() => handleView(params?.row, true)}>
                        <PrintIcon />
                    </IconButton>
                </Tooltip>
            </Stack>
        ),
        ...allyProps
    }
];

export const THERAPY_EVENTS = {
    EVALUATION: 0,
    TREATMENT: 1
};

export const treatmentCols = (handleView, treatmentSelectAll, checkedRows, handleRowSelectionChange, handleAllSelect) => [
    {
        sortable: false,
        field: 'checkbox',
        renderHeader: () => <Checkbox checked={treatmentSelectAll} onChange={handleAllSelect} />,
        renderCell: (params) => (
            <Checkbox
                checked={checkedRows.includes(params.row.id)}
                onChange={() => {
                    handleRowSelectionChange(params.row.id);
                }}
            />
        ),
        width: 100
    },
    {
        field: 'date',
        headerName: 'Date',
        valueGetter: (value, row) => utcToLocal(row?.date),
        ...allyProps
    },
    {
        field: 'patient__name',
        headerName: 'Patient',
        ...allyProps,
        renderCell: (params) => <PatientLink name={params.row?.patient_name} id={params.row?.patient_id} />
    },
    {
        field: 'service_code',
        headerName: 'Service',
        ...allyProps
    },
    {
        field: 'location_name',
        headerName: 'Location',
        ...allyProps
    },
    {
        field: 'therapist',
        headerName: 'Therapist',
        ...allyProps
    },
    {
        field: 'actions',
        headerName: 'Actions',
        renderCell: (params) => (
            <Stack
                direction="row"
                sx={{
                    alignItems: "center",
                    width: '100%'
                }}>
                <Tooltip title="Print">
                    <IconButton color="secondary" onClick={() => handleView(params?.row, true)}>
                        <PrintIcon />
                    </IconButton>
                </Tooltip>
            </Stack>
        ),
        ...allyProps
    }
];
